import React, { Component } from 'react'

class Hello extends Component {
  render() {
	  return (
		<div className="container">
		  <div className="jumbotron jumbotron-fluid">
			<h2>It's my words</h2>
			<p>Сервис для изучения английских слов. Личный словарь, в который можно добавлять английские слова из любого текста и тренеровать их.</p><br />

				<ol>
					<li>Очень мощный анализатор текста. Сервис приведет слова к начальной форме и добавит в ваш личный словарь, исключая дубли.</li><br />
					<li>Минималистичный и простой тренажер для изучения слов.</li><br />
					<li>Поддерживает мобильные устройства.</li><br />
				</ol>
				<br />
				<div className="text-center">
					<button type="button" className="btn btn-success btn-lg" onClick={this.props.toggleRegistrationModal}>Зарегистрироваться</button>
				</div>
		  </div>
		</div>
	  );
	}
}

export default Hello;



// WEBPACK FOOTER //
// ./src/components/Hello.js